import axios from 'axios'

// 用户登录
export const login = (userData) => {
  return axios.post('/user/login', userData)
}

// 无感刷新：用 refreshToken 换取新的 token 和 refreshToken
export const refreshToken = (refreshTokenValue) => {
  return axios.post('/user/refresh', {}, {
    headers: { 'Refresh-Token': refreshTokenValue }
  })
}
